export default {
  trackEvent: (payload, callback) => {
    if (window.utag) {
      utag.link(payload, callback)
    }
  },
  trackPageView: (payload, callback) => {
    if (window.utag) {
      utag.view(payload, callback)
    }
  }
}
